/*
 * Copyright (c) 2021 Honeywell International, Inc. All rights reserved.
 *
 * This file contains trade secrets of Honeywell International, Inc.  No part
 *  may be reproduced or transmitted in any form by any means or for any
 *  purpose without the express written permission of Honeywell.
 *
 */
import React, {useEffect, useState} from 'react';
import {Card} from '@scuf/common';
import './DIYGatewayManagementApp.scss';
import { UserManager } from '@forge/sso-client/dist'
import GlobalStore from "../../stores/GlobalStore/GlobalStore";
import {FCDIYAppRouteFacade} from "../../components/fcauth/FCDIYAppRouteFacade";
import {inject} from "mobx-react";

/**
 * Wrapper for FC platform gateway management DIY application.
 */
export interface IFCPDIYGatewayManagementAppWrapper {
    globalStore: GlobalStore;
}

export const FCPDIYGatewayManagementAppWrapperInternal = (props: IFCPDIYGatewayManagementAppWrapper) => {

    const [ready, setReady] = useState(false);

    useEffect(() => {
        if (props.globalStore!.envVariables) {
            createUserManager();
            setReady(true);
        }
    },[props.globalStore!.envVariables]);

    const getAppLoadingMessage = () => {
        return <div className="ui-msg-block"><Card>
            <Card.Content>
                <div className="ui-loading-msg">
                    Initializing application
                </div>
            </Card.Content>
        </Card></div>;
    };

    const createUserManager = () => {
        let envVars = props.globalStore!.envVariables;
        UserManager.createInstance({
            authority: envVars.FORGE_IAM_AUTHORITY,
            client_id: envVars.FC_CLIENT_ID,
            response_type: 'code',
            scope: envVars.FC_IAM_REQUESTED_SCOPES,
            redirect_uri: `${window.location.origin}/fcp/register/callback`,
            post_logout_redirect_uri: `${window.location.origin}/fcp/register/main`,
            automaticSilentRenew: true
        });
    }

   return (ready) ? <FCDIYAppRouteFacade /> : getAppLoadingMessage();
};

export const FCPDIYGatewayManagementAppWrapper = inject('globalStore')(FCPDIYGatewayManagementAppWrapperInternal);